export default __webpack_public_path__ + "685e09e4146c600a4e773bc96dd7c2e1.png";